<template>
    <div class="full">
        <div class="main">
            <router-view />
        </div>
        <pro-navigation />
    </div>
</template>

<script>
import proNavigation from "@/components/Pro/pro-navigation";
export default {
    name: "pro",
    components: { proNavigation },
};
</script>

<style lang="scss">
.full {
    //height:100%;
    //min-height: -webkit-fill-available;
}
</style>
